import { DateTime, DurationLike } from "luxon";
import { TZProps } from "../utils/globalTypes";
import Timezone from "@/src/helpers/timezone.json";

export const getExpired = () => {
  const today = DateTime.now();
  const later = today.plus({ seconds: 30 });

  return later.toISO();
};

export const countDown = (next: string) => {
  const today = DateTime.now();
  const later = DateTime.fromISO(next);
  const diff = later.diff(today, ["seconds"]);
  const sec = Number(diff.seconds.toFixed(0));

  return sec;
};

export const getToday = (type = "normal" as "normal" | "raw") => {
  const today = DateTime.now();
  if (type === "raw") {
    return today;
  }

  return today.toISO();
};

export const toRelative = (input: string, from = "SQL", type = "normal") => {
  let res = DateTime.fromSQL(input).toRelative();

  if (from === "ISO") {
    res = DateTime.fromISO(input).toRelative();
  }

  if (type === "future") {
    const future = res?.replace("in ", "");
    return `${future} left`;
  }

  return res;
};

export const dateFormat = (input: string, from = "SQL", format = "full") => {
  let date = DateTime.fromSQL(input);
  if (from === "ISO") {
    date = DateTime.fromISO(input, { setZone: true });
  }

  let humanReadable = date.toFormat("dd LLL yyyy, t");
  if (format === "short") {
    humanReadable = date.toFormat("dd LLL yyyy");
  } else if (format === "without_year") {
    humanReadable = date.toFormat("dd LLL, t");
  } else if (format === "for_auctions") {
    humanReadable = date.toFormat("dd LLL yyyy, t ZZZZ");
  } else if (format === "short_comma") {
    humanReadable = date.toFormat("dd LLL, yyyy");
  }

  return humanReadable;
};

export const detectZoneName = (input: string | null, from = "SQL") => {
  if (!input) {
    return "";
  }
  let date = DateTime.fromSQL(input);
  if (from === "ISO") {
    date = DateTime.fromISO(input, { setZone: true });
  }
  return date.zoneName;
};

export const dayName = (input: string) => {
  switch (input) {
    case "mon":
      return "Monday";
    case "tue":
      return "Tuesday";
    case "wed":
      return "Wednesday";
    case "thu":
      return "Thursday";
    case "fri":
      return "Friday";
    case "sat":
      return "Saturday";

    default:
      return "Sunday";
  }
};

export const shortDayName = (input: string) => {
  switch (input) {
    case "monday":
      return "mon";
    case "tuesday":
      return "tue";
    case "wednesday":
      return "wed";
    case "thursday":
      return "thu";
    case "friday":
      return "fri";
    case "saturday":
      return "sat";

    default:
      return "sun";
  }
};

export const addDate = (input: string, from = "SQL", add: DurationLike) => {
  let date = DateTime.fromSQL(input);
  if (from === "ISO") {
    date = DateTime.fromISO(input, { setZone: true });
  }

  let humanReadable = date.toFormat("dd LLL yyyy, t");

  if (!add) {
    return humanReadable;
  }

  const newDate = date.plus(add);
  humanReadable = newDate.toFormat("dd LLL yyyy, t");

  return humanReadable;
};

export const findTimezone = (abbr: string, type = "abbr" as any) => {
  const tz = Timezone as TZProps[];
  let cek = tz.filter((v) => v.abbr === abbr);
  if (type === "utc") {
    cek = tz.filter((v) => v.utc.includes(abbr));
  }
  if (cek.length > 0) {
    return cek[0].value;
  }

  return "not found";
};

export const findTimezoneUTC = (utc: string | null) => {
  if (!utc) {
    return "";
  }
  const tz = Timezone as TZProps[];
  const cek = tz.filter((v) => v.utc.includes(utc));
  if (cek.length > 0) {
    return cek[0].abbr;
  }

  return "not found";
};

export const quickDateFormat = (input: string, format: string) => {
  const date = DateTime.fromISO(input);
  const humanReadable = date.toFormat(format);

  return humanReadable;
};
